import Script from './script'
import ENV from '../env'

export default class Xenio {
  static getXenio () {
    return document.getElementById('xenioo-chat-widget')
  }

  static show () {
    if (!ENV.api.xenioId) {
      return
    }
    Script.fromCode('Xenioo("' + ENV.api.xenioId + '")')

    let xenioo = this.getXenio()

    if (xenioo) {
      xenioo.style.display = 'inherit'
    }
  }

  static hide () {
    if (!ENV.api.xenioId) {
      return
    }
    let xenioo = this.getXenio()

    if (xenioo) {
      xenioo.style.display = 'none'
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/xenio.js